import {createReducer} from '@reduxjs/toolkit';
import {selectResult} from '../actions/geocoder.js';
import {setSize, setView, setZoom, toggleLabels} from '../actions/map.js';
import {ASPECT_RATIO, DEFAULT_EXTENT, STORY_WIDTH} from '../constants.js';

const defaultState = {
  size: {
    width: STORY_WIDTH,
    height: STORY_WIDTH / ASPECT_RATIO,
  },
  view: {
    extent: DEFAULT_EXTENT,
    center: [0, 0],
    zoom: 2,
    minZoom: 2,
  },
  labels: false,
};

export default createReducer(defaultState, builder => {
  builder.addCase(setView, (state, {payload: view}) => {
    state.view = view;
  });
  builder.addCase(setZoom, (state, {payload: zoom}) => {
    state.view.zoom = zoom;
  });
  builder.addCase(setSize, (state, {payload: size}) => {
    state.size = size;
  });
  builder.addCase(toggleLabels, state => {
    state.labels = !state.labels;
  });
  builder.addCase(selectResult, (state, {payload: result}) => {
    if (result) {
      if (result?.bbox) {
        state.view = {
          extent: result.bbox,
        };
      } else {
        state.view.center = result.center;
        state.view.zoom = 15;
      }
    }
  });
});
